import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import EstacionInput from '../../components/EstacionInput';
import LineaInput from '../../components/LineaInput';
import { MapContainer, TileLayer, CircleMarker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';






function MapaHabilitacionesInner({ habsLin, filtro = 'todas' }) {
  const map = useMap();

  React.useEffect(() => {
    if (!map) return;
    const layers = [];

    // Líneas habilitadas
    const coloresPorTipo = { AV: '#2563eb', AD: '#ea580c', MIXTA: '#16a34a' };
    const paleta = ['#2563eb','#dc2626','#16a34a','#9333ea','#ea580c','#0891b2','#65a30d','#d97706','#be185d','#0d9488'];
    habsLin.forEach((h, i) => {
      if ((h.lat_inicio || h.latitud_inicio) && (h.lon_inicio || h.longitud_inicio) && (h.lat_fin || h.latitud_fin) && (h.lon_fin || h.longitud_fin)) {
        const color = filtro === 'todas' ? (coloresPorTipo[h.tipo_red] || '#2563eb') : paleta[i % paleta.length];
        const puntos = h.puntos && h.puntos.length > 1 
          ? h.puntos 
          : [[h.lat_inicio || h.latitud_inicio, h.lon_inicio || h.longitud_inicio], [h.lat_fin || h.latitud_fin, h.lon_fin || h.longitud_fin]];
        const linea = L.polyline(puntos, { color, weight: 4, opacity: 0.9 }).addTo(map);
        linea.bindPopup(`<strong>${h.cod_linea}</strong><br>${h.estacion_inicio} → ${h.estacion_fin}`);
        layers.push(linea);

        // Marcadores inicio y fin
        if (h.lat_inicio && h.lat_fin) {
          const mI = L.circleMarker([h.lat_inicio, h.lon_inicio], {
            radius: 7, fillColor: color, color: 'white', weight: 2, fillOpacity: 1
          }).addTo(map);
          mI.bindPopup(`<strong>${h.estacion_inicio}</strong><br>Inicio`);
          layers.push(mI);
          const mF = L.circleMarker([h.lat_fin, h.lon_fin], {
            radius: 7, fillColor: color, color: 'white', weight: 2, fillOpacity: 1
          }).addTo(map);
          mF.bindPopup(`<strong>${h.estacion_fin}</strong><br>Fin`);
          layers.push(mF);
        }

      }
    });

    return () => layers.forEach(l => { try { map.removeLayer(l); } catch {} });
  }, [map, habsLin]);

  return null;
}

function MapaHabilitaciones({ habsLin, filtro = 'todas' }) {
  const [habsConCoords, setHabsConCoords] = React.useState([]);

  React.useEffect(() => {
    const enriquecer = async () => {
      const token = localStorage.getItem('token');
      const BASE_DEPS = "https://services7.arcgis.com/XTupIrLX53AjaJqO/arcgis/rest/services/Dependencias_Adif_p%C3%BAblico/FeatureServer/0/query";
      const enriched = await Promise.all(habsLin.map(async h => {
        let latI = null, lonI = null, latF = null, lonF = null;
        let puntosIntermedios = [];

        // Obtener coords estacion inicio
        if (h.cod_estacion_inicio) {
          try {
            const r = await fetch(`/api/dependencias/?cod=${encodeURIComponent(h.cod_estacion_inicio || '')}&limit=1`, { headers: { 'Authorization': `Bearer ${token}` } });
            const data = await r.json();
            if (data.length > 0) { latI = data[0].lat; lonI = data[0].lon; }
          } catch {}
        }

        // Obtener coords estacion fin
        if (h.cod_estacion_fin) {
          try {
            const r = await fetch(`/api/dependencias/?cod=${encodeURIComponent(h.cod_estacion_fin || '')}&limit=1`, { headers: { 'Authorization': `Bearer ${token}` } });
            const data = await r.json();
            if (data.length > 0) { latF = data[0].lat; lonF = data[0].lon; }
          } catch {}
        }

        // Obtener geometria real de ADIF para esta linea
        if (h.cod_linea && latI && lonI && latF && lonF) {
          try {
            const codNum = h.cod_linea.split('-')[0].trim().replace(/\s+/g, '').substring(0,3);
            const BASE = "https://services7.arcgis.com/XTupIrLX53AjaJqO/arcgis/rest/services/Red_Ferroviaria_de_Inter%C3%A9s_General___Adif__RFIG_CM_vista_2/FeatureServer/43/query";
            const filtro = `COD_LINEA LIKE '${codNum}%'`;
            const url = `${BASE}?f=geojson&where=${encodeURIComponent(filtro)}&outFields=COD_LINEA,CODTRAMO,PKI,PKD&resultRecordCount=500`;
            const r = await fetch(url);
            const data = await r.json();
            
            if (data.features && data.features.length > 0) {
              // Extraer todos los puntos de la geometria
              // Encadenar segmentos por proximidad desde el punto inicio
              const distFn = (a, b) => Math.sqrt((a[0]-b[0])**2 + (a[1]-b[1])**2);
              
              let segments = data.features
                .filter(f => f.geometry && f.geometry.coordinates)
                .map(f => f.geometry.type === 'MultiLineString'
                  ? f.geometry.coordinates.flat()
                  : f.geometry.coordinates);

              if (segments.length > 0) {
                // Ordenar segmentos encadenandolos por el extremo mas cercano desde inicio de linea
                let ordered = [segments[0]];
                let remaining = segments.slice(1);
                
                while (remaining.length > 0) {
                  const last = ordered[ordered.length - 1];
                  const lastPt = last[last.length - 1];
                  let bestIdx = 0, bestDist = Infinity, bestReverse = false;
                  
                  remaining.forEach((seg, i) => {
                    const d1 = distFn(lastPt, seg[0]);
                    const d2 = distFn(lastPt, seg[seg.length - 1]);
                    if (d1 < bestDist) { bestDist = d1; bestIdx = i; bestReverse = false; }
                    if (d2 < bestDist) { bestDist = d2; bestIdx = i; bestReverse = true; }
                  });
                  
                  const next = remaining[bestIdx];
                  ordered.push(bestReverse ? [...next].reverse() : next);
                  remaining.splice(bestIdx, 1);
                }
                
                // Unir todos los puntos
                let allPts = ordered.flat().map(c => [c[1], c[0]]);
                
                // Encontrar indices mas cercanos a inicio y fin
                const idxI = allPts.reduce((best, p, i) => distFn(p, [latI, lonI]) < distFn(allPts[best], [latI, lonI]) ? i : best, 0);
                const idxF = allPts.reduce((best, p, i) => distFn(p, [latF, lonF]) < distFn(allPts[best], [latF, lonF]) ? i : best, 0);
                const desde = Math.min(idxI, idxF);
                const hasta = Math.max(idxI, idxF);
                puntosIntermedios = allPts.slice(desde, hasta + 1);
              }
            }
          } catch(e) { console.error('Error geometria:', e); }
        }

        return { ...h, latitud_inicio: latI, longitud_inicio: lonI, latitud_fin: latF, longitud_fin: lonF, puntos: puntosIntermedios };
      }));
      setHabsConCoords(enriched);
    };
    if (habsLin.length > 0) enriquecer();
  }, [habsLin]);

  return (
    <div>
      <div style={{ marginBottom: 12, fontSize: 13, color: '#555' }}>
        {habsLin.length} líneas habilitadas — <span style={{ color: '#16a34a' }}>● inicio</span> · <span style={{ color: '#dc2626' }}>● fin</span>
      </div>
      <div style={{ borderRadius: 12, overflow: 'hidden', border: '1px solid #e5e5e5', height: 500, position: 'relative' }}>
        <MapContainer center={[40.4, -3.7]} zoom={6} style={{ height: '100%', width: '100%' }}>
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="© OpenStreetMap" />
          <MapaHabilitacionesInner habsLin={habsConCoords} filtro={filtro} />
          <div style={{
            position: 'absolute', bottom: 24, right: 8, zIndex: 1000,
            background: 'rgba(255,255,255,0.92)', borderRadius: 8, padding: '8px 12px',
            fontSize: 11, boxShadow: '0 1px 4px rgba(0,0,0,0.15)'
          }}>
            <div style={{ fontWeight: 600, marginBottom: 4, color: '#333' }}>Leyenda</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 3 }}>
              <div style={{ width: 20, height: 3, background: '#2563eb', borderRadius: 2 }}></div>
              <span style={{ color: '#555' }}>AV</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 3 }}>
              <div style={{ width: 20, height: 3, background: '#ea580c', borderRadius: 2 }}></div>
              <span style={{ color: '#555' }}>Convencional</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <div style={{ width: 20, height: 3, background: '#16a34a', borderRadius: 2 }}></div>
              <span style={{ color: '#555' }}>Mixta</span>
            </div>
          </div>
        </MapContainer>
      </div>
    </div>
  );
}

export default function FichaMaquinista() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [maquinista, setMaquinista] = useState(null);
  const [tab, setTab] = useState('habilitaciones');
  const [habsMat, setHabsMat] = useState([]);
  const [habsLin, setHabsLin] = useState([]);
  const [editandoLinea, setEditandoLinea] = useState(null);
  const [historial, setHistorial] = useState([]);
  const [filtroHistorial, setFiltroHistorial] = useState({ desde: '', hasta: '', locomotora: '' });
  const [filtroMapa, setFiltroMapa] = useState('todas');
  const [formEditLinea, setFormEditLinea] = useState({});

  const cargarHistorial = async () => {
    const r = await api.get(`/maquinistas/${id}/historial`);
    setHistorial(r.data);
  };

  const guardarLinea = async (habId) => {
    await api.patch(`/maquinistas/${id}/habilitaciones-linea/${habId}`, formEditLinea);
    setEditandoLinea(null);
    cargar();
  };
  const [reconocimientos, setReconocimientos] = useState([]);
  const [servicios, setServicios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const [lineasDisponibles, setLineasDisponibles] = useState([]);

  useEffect(() => {
    cargar();
  }, [id]);

  const cargar = async () => {
    setLoading(true);
    const [maqRes, matRes, linRes, recRes, servRes] = await Promise.all([
      api.get('/maquinistas/'),
      api.get(`/maquinistas/${id}/habilitaciones-material`),
      api.get(`/maquinistas/${id}/habilitaciones-linea`),
      api.get(`/maquinistas/${id}/reconocimientos`),
      api.get(`/servicios/?locomotora_id=0`).catch(() => ({ data: [] }))
    ]);
    const m = maqRes.data.find(x => x.id === parseInt(id));
    setMaquinista(m);
    setHabsMat(matRes.data);
    setHabsLin(linRes.data);
    setReconocimientos(recRes.data);
    setLoading(false);

    // Cargar lineas disponibles de ADIF
    try {
      const url = "https://services7.arcgis.com/XTupIrLX53AjaJqO/arcgis/rest/services/Red_Ferroviaria_de_Inter%C3%A9s_General___Adif__RFIG_CM_vista_2/FeatureServer/43/query?f=json&where=CODTRAMO+LIKE+'11%25'+OR+CODTRAMO+LIKE+'12%25'+OR+CODTRAMO+LIKE+'13%25'+OR+CODTRAMO+LIKE+'14%25'&outFields=COD_LINEA&returnDistinctValues=true&resultRecordCount=100";
      const r = await fetch(url);
      const data = await r.json();
      const lineas = [...new Set(data.features.map(f => f.attributes.COD_LINEA).filter(Boolean))].sort();
      setLineasDisponibles(lineas);
    } catch {}
  };

  const borrar = async (tipo, habId) => {
    if (!window.confirm('¿Eliminar?')) return;
    await api.delete(`/maquinistas/${tipo}/${habId}`);
    cargar();
  };

  const guardar = async () => {
    setSaving(true);
    try {
      if (modal === 'material') {
        await api.post(`/maquinistas/${id}/habilitaciones-material`, form);
      } else if (modal === 'linea') {
        await api.post(`/maquinistas/${id}/habilitaciones-linea`, form);
      } else if (modal === 'medico') {
        await api.post(`/maquinistas/${id}/reconocimientos`, form);
      }
      setModal(null);
      setForm({});
      cargar();
    } catch (e) {
      alert('Error al guardar');
    } finally {
      setSaving(false);
    }
  };

  const diasHasta = (fecha) => {
    if (!fecha) return null;
    return Math.ceil((new Date(fecha) - new Date()) / 86400000);
  };

  const colorFecha = (fecha) => {
    const d = diasHasta(fecha);
    if (d === null) return '#888';
    if (d < 0) return '#a32d2d';
    if (d < 60) return '#854f0b';
    return '#3b6d11';
  };

  if (loading) return <div style={{ padding: 40, color: '#888' }}>Cargando...</div>;
  if (!maquinista) return <div style={{ padding: 40, color: '#888' }}>Maquinista no encontrado</div>;

  const tabs = [
    { key: 'habilitaciones', label: 'Habilitaciones' },
    { key: 'medicos', label: 'Médicos' },
    { key: 'historial', label: 'Historial', onSelect: cargarHistorial },
    { key: 'mapa', label: 'Mapa' },
  ];

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
        <button onClick={() => navigate('/staff/maquinistas')} style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 14 }}>←</button>
        <div>
          <h2 style={{ fontSize: 22, fontWeight: 500, margin: 0 }}>{maquinista.nombre} {maquinista.apellidos}</h2>
          <p style={{ fontSize: 13, color: '#888', margin: '2px 0 0' }}>{maquinista.dni} · {maquinista.email}</p>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 6, marginBottom: 20, borderBottom: '1px solid #e5e5e5' }}>
        {tabs.map(t => (
          <button key={t.key} onClick={() => { setTab(t.key); t.onSelect && t.onSelect(); }} style={{
            padding: '10px 16px', border: 'none', background: 'transparent', cursor: 'pointer', fontSize: 14,
            fontWeight: tab === t.key ? 600 : 400, color: tab === t.key ? '#1a1a1a' : '#888',
            borderBottom: tab === t.key ? '2px solid #1a1a1a' : '2px solid transparent', marginBottom: -1
          }}>{t.label}</button>
        ))}
      </div>

      {tab === 'habilitaciones' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <div style={{ fontSize: 14, fontWeight: 500 }}>Material rodante</div>
              <button onClick={() => { setModal('material'); setForm({}); }}
                style={{ padding: '5px 12px', borderRadius: 8, border: 'none', background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 12 }}>
                + Añadir
              </button>
            </div>
            <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', overflow: 'hidden' }}>
              {habsMat.length === 0 && <div style={{ padding: 20, textAlign: 'center', color: '#aaa', fontSize: 13 }}>Sin habilitaciones</div>}
              {habsMat.map(h => (
                <div key={h.id} style={{ padding: '12px 16px', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontWeight: 500, fontSize: 14 }}>🚂 {h.modelo}</div>
                    <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>
                      {h.fecha_desde && `Desde: ${h.fecha_desde}`}
                      {h.fecha_hasta && <span style={{ color: colorFecha(h.fecha_hasta), marginLeft: 8 }}>Hasta: {h.fecha_hasta}</span>}
                    </div>
                  </div>
                  <button onClick={() => borrar('habilitaciones-material', h.id)}
                    style={{ padding: '3px 8px', borderRadius: 6, border: '1px solid #fcc', background: '#fff5f5', cursor: 'pointer', fontSize: 11, color: '#c00' }}>
                    Eliminar
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <div style={{ fontSize: 14, fontWeight: 500 }}>Líneas de infraestructura</div>
              <button onClick={() => { setModal('linea'); setForm({}); }}
                style={{ padding: '5px 12px', borderRadius: 8, border: 'none', background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 12 }}>
                + Añadir
              </button>
            </div>
            <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', overflow: 'hidden' }}>
              {habsLin.length === 0 && <div style={{ padding: 20, textAlign: 'center', color: '#aaa', fontSize: 13 }}>Sin habilitaciones</div>}
              {habsLin.map(h => (
                <div key={h.id} style={{ padding: '12px 16px', borderBottom: '1px solid #f0f0f0' }}>
                  {editandoLinea === h.id ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                      <div style={{ fontWeight: 500, fontSize: 13 }}>🛤️ {h.nombre_linea || h.cod_linea}</div>
                      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                        <div>
                          <label style={{ display: 'block', fontSize: 11, color: '#555', marginBottom: 2 }}>Tipo</label>
                          <select value={formEditLinea.tipo_red ?? h.tipo_red ?? 'AD'}
                            onChange={e => setFormEditLinea({...formEditLinea, tipo_red: e.target.value})}
                            style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid #ddd', fontSize: 12 }}>
                            <option value="AV">AV</option>
                            <option value="AD">Convencional</option>
                            <option value="MIXTA">Mixta</option>
                          </select>
                        </div>
                        <div>
                          <label style={{ display: 'block', fontSize: 11, color: '#555', marginBottom: 2 }}>Desde</label>
                          <input type="date" value={formEditLinea.fecha_desde ?? h.fecha_desde ?? ''}
                            onChange={e => setFormEditLinea({...formEditLinea, fecha_desde: e.target.value})}
                            style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid #ddd', fontSize: 12 }} />
                        </div>
                        <div>
                          <label style={{ display: 'block', fontSize: 11, color: '#555', marginBottom: 2 }}>Hasta</label>
                          <input type="date" value={formEditLinea.fecha_hasta ?? h.fecha_hasta ?? ''}
                            onChange={e => setFormEditLinea({...formEditLinea, fecha_hasta: e.target.value})}
                            style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid #ddd', fontSize: 12 }} />
                        </div>
                        <div>
                          <label style={{ display: 'block', fontSize: 11, color: '#555', marginBottom: 2 }}>Est. inicio</label>
                          <input value={formEditLinea.estacion_inicio ?? h.estacion_inicio ?? ''}
                            onChange={e => setFormEditLinea({...formEditLinea, estacion_inicio: e.target.value})}
                            style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid #ddd', fontSize: 12, width: 150 }} />
                        </div>
                        <div>
                          <label style={{ display: 'block', fontSize: 11, color: '#555', marginBottom: 2 }}>Est. fin</label>
                          <input value={formEditLinea.estacion_fin ?? h.estacion_fin ?? ''}
                            onChange={e => setFormEditLinea({...formEditLinea, estacion_fin: e.target.value})}
                            style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid #ddd', fontSize: 12, width: 150 }} />
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button onClick={() => guardarLinea(h.id)}
                          style={{ padding: '4px 12px', borderRadius: 6, border: 'none', background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 12 }}>Guardar</button>
                        <button onClick={() => setEditandoLinea(null)}
                          style={{ padding: '4px 12px', borderRadius: 6, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 12 }}>Cancelar</button>
                      </div>
                    </div>
                  ) : (
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        <div style={{ fontWeight: 500, fontSize: 13 }}>🛤️ {h.nombre_linea || h.cod_linea}</div>
                        <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>
                          {h.estacion_inicio && <span>{h.estacion_inicio} → {h.estacion_fin}</span>}
                          {h.fecha_desde && <span style={{ marginLeft: 8 }}>Desde: {h.fecha_desde}</span>}
                          {h.fecha_hasta && <span style={{ color: colorFecha(h.fecha_hasta), marginLeft: 8 }}>Hasta: {h.fecha_hasta}</span>}
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button onClick={() => { setEditandoLinea(h.id); setFormEditLinea({}); }}
                          style={{ padding: '3px 8px', borderRadius: 6, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 11, color: '#555' }}>
                          Editar
                        </button>
                        <button onClick={() => borrar('habilitaciones-linea', h.id)}
                          style={{ padding: '3px 8px', borderRadius: 6, border: '1px solid #fcc', background: '#fff5f5', cursor: 'pointer', fontSize: 11, color: '#c00' }}>
                          Eliminar
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {tab === 'medicos' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <div style={{ fontSize: 14, fontWeight: 500 }}>Reconocimientos médicos</div>
            <button onClick={() => { setModal('medico'); setForm({}); }}
              style={{ padding: '5px 12px', borderRadius: 8, border: 'none', background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 12 }}>
              + Añadir
            </button>
          </div>
          <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', overflow: 'hidden' }}>
            {reconocimientos.length === 0 && <div style={{ padding: 24, textAlign: 'center', color: '#aaa', fontSize: 13 }}>Sin reconocimientos registrados</div>}
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              {reconocimientos.length > 0 && (
                <thead>
                  <tr style={{ background: '#f8f8f6' }}>
                    <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Tipo</th>
                    <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Fecha</th>
                    <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Caducidad</th>
                    <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Resultado</th>
                    <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Centro</th>
                    <th style={{ padding: '10px 14px' }}></th>
                  </tr>
                </thead>
              )}
              <tbody>
                {reconocimientos.map(r => (
                  <tr key={r.id} style={{ borderTop: '1px solid #f0f0f0' }}>
                    <td style={{ padding: '10px 14px', fontWeight: 500 }}>{r.tipo}</td>
                    <td style={{ padding: '10px 14px' }}>{r.fecha}</td>
                    <td style={{ padding: '10px 14px', color: colorFecha(r.fecha_caducidad), fontWeight: 500 }}>{r.fecha_caducidad || '—'}</td>
                    <td style={{ padding: '10px 14px' }}>{r.resultado || '—'}</td>
                    <td style={{ padding: '10px 14px', color: '#888' }}>{r.centro || '—'}</td>
                    <td style={{ padding: '10px 14px' }}>
                      <button onClick={() => borrar('reconocimientos', r.id)}
                        style={{ padding: '3px 8px', borderRadius: 6, border: '1px solid #fcc', background: '#fff5f5', cursor: 'pointer', fontSize: 11, color: '#c00' }}>
                        Eliminar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {tab === 'mapa' && (
        <div>
          <div style={{ display: 'flex', gap: 6, marginBottom: 12 }}>
            {[['todas','Todas'],['AV','AV'],['AD','Convencional'],['MIXTA','Mixta']].map(([val, label]) => (
              <button key={val} onClick={() => setFiltroMapa(val)} style={{
                padding: '5px 12px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 500,
                background: filtroMapa === val ? '#1a1a1a' : '#f0f0f0',
                color: filtroMapa === val ? '#fff' : '#555'
              }}>{label}</button>
            ))}
          </div>
          <MapaHabilitaciones habsLin={habsLin.filter(h => filtroMapa === 'todas' || h.tipo_red === filtroMapa)} filtro={filtroMapa} />
        </div>
      )}

      {tab === 'historial' && (
        <div>
          {/* Filtros */}
          <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
            <div>
              <label style={{ display: 'block', fontSize: 11, color: '#555', marginBottom: 2 }}>Desde</label>
              <input type="date" value={filtroHistorial.desde}
                onChange={e => setFiltroHistorial({...filtroHistorial, desde: e.target.value})}
                style={{ padding: '6px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 12 }} />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 11, color: '#555', marginBottom: 2 }}>Hasta</label>
              <input type="date" value={filtroHistorial.hasta}
                onChange={e => setFiltroHistorial({...filtroHistorial, hasta: e.target.value})}
                style={{ padding: '6px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 12 }} />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 11, color: '#555', marginBottom: 2 }}>Locomotora</label>
              <input placeholder="ej: 336001" value={filtroHistorial.locomotora}
                onChange={e => setFiltroHistorial({...filtroHistorial, locomotora: e.target.value})}
                style={{ padding: '6px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 12, width: 100 }} />
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
              <button onClick={() => setFiltroHistorial({ desde: '', hasta: '', locomotora: '' })}
                style={{ padding: '6px 12px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 12, color: '#555' }}>
                Limpiar
              </button>
            </div>
          </div>

          {(() => {
            const filtrado = historial.filter(s => {
              if (filtroHistorial.desde && s.fecha < filtroHistorial.desde) return false;
              if (filtroHistorial.hasta && s.fecha > filtroHistorial.hasta) return false;
              if (filtroHistorial.locomotora && !(s.locomotora || '').includes(filtroHistorial.locomotora)) return false;
              return true;
            });

            if (filtrado.length === 0) return (
              <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', padding: 40, textAlign: 'center', color: '#888' }}>
                <div style={{ fontSize: 32, marginBottom: 8 }}>📋</div>
                <div style={{ fontSize: 14 }}>Sin partes registrados</div>
              </div>
            );

            return (
              <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', overflow: 'hidden' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                  <thead>
                    <tr style={{ background: '#f8f8f6' }}>
                      <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Fecha</th>
                      <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Locomotora</th>
                      <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Recorrido</th>
                      <th style={{ padding: '10px 16px', textAlign: 'center', fontWeight: 500, color: '#555' }}>KM</th>
                      <th style={{ padding: '10px 16px', textAlign: 'center', fontWeight: 500, color: '#555' }}>PDFs</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filtrado.map(s => (
                      <tr key={s.id} style={{ borderTop: '1px solid #f0f0f0' }}>
                        <td style={{ padding: '10px 16px', fontWeight: 500 }}>{s.fecha}</td>
                        <td style={{ padding: '10px 16px' }}>{s.locomotora ? `🚂 ${s.locomotora}` : '—'}</td>
                        <td style={{ padding: '10px 16px', color: '#555' }}>{s.recorrido || s.descripcion || '—'}</td>
                        <td style={{ padding: '10px 16px', textAlign: 'center', color: '#888' }}>
                          {s.km_totales ? `${s.km_totales} km` : '—'}
                        </td>
                        <td style={{ padding: '10px 16px', textAlign: 'center' }}>
                          <div style={{ display: 'flex', gap: 4, justifyContent: 'center' }}>
                            {s.pdf_checklist_previo && (
                              <a href={`/api/pdf/${s.pdf_checklist_previo}`} target="_blank" rel="noreferrer"
                                style={{ padding: '3px 8px', borderRadius: 6, border: '1px solid #ddd', background: '#fff', fontSize: 11, color: '#555', textDecoration: 'none' }}>
                                Ch. Previo
                              </a>
                            )}
                            {s.pdf_parte && (
                              <a href={`/api/pdf/${s.pdf_parte}`} target="_blank" rel="noreferrer"
                                style={{ padding: '3px 8px', borderRadius: 6, border: '1px solid #ddd', background: '#fff', fontSize: 11, color: '#555', textDecoration: 'none' }}>
                                Parte
                              </a>
                            )}
                            {s.pdf_checklist_final && (
                              <a href={`/api/pdf/${s.pdf_checklist_final}`} target="_blank" rel="noreferrer"
                                style={{ padding: '3px 8px', borderRadius: 6, border: '1px solid #ddd', background: '#fff', fontSize: 11, color: '#555', textDecoration: 'none' }}>
                                Ch. Final
                              </a>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            );
          })()}
        </div>
      )}

      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200 }}
          onClick={e => { if (e.target === e.currentTarget) setModal(null); }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 28, width: 420, maxWidth: '95vw' }}>
            <h3 style={{ fontSize: 16, fontWeight: 500, marginBottom: 20 }}>
              {modal === 'material' ? 'Nueva habilitación de material' : modal === 'linea' ? 'Nueva habilitación de línea' : 'Nuevo reconocimiento médico'}
            </h3>

            {modal === 'material' && (
              <>
                <div style={{ marginBottom: 12 }}>
                  <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Modelo *</label>
                  <select value={form.modelo || ''} onChange={e => setForm({ ...form, modelo: e.target.value })}
                    style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }}>
                    <option value="">Seleccionar...</option>
                    {['336', '252', '253', '102', '103', '104', '130'].map(m => <option key={m} value={m}>Serie {m}</option>)}
                  </select>
                </div>
              </>
            )}

            {modal === 'linea' && (
              <>
                <div style={{ marginBottom: 12 }}>
                  <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Línea *</label>
                  <LineaInput value={form.cod_linea || ''} onChange={v => setForm({ ...form, cod_linea: v, nombre_linea: v })} placeholder="Buscar línea ADIF..." />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
                  <div>
                    <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Estacion inicio</label>
                    <EstacionInput value={form.estacion_inicio || ''} onChange={(v, dep) => setForm({ ...form, estacion_inicio: v, cod_estacion_inicio: dep?.cod_depend })} codLinea={form.cod_linea} soloAv={false} />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Estacion fin</label>
                    <EstacionInput value={form.estacion_fin || ''} onChange={(v, dep) => setForm({ ...form, estacion_fin: v, cod_estacion_fin: dep?.cod_depend })} codLinea={form.cod_linea} soloAv={false} />
                  </div>
                </div>
              </>
            )}

            {modal === 'medico' && (
              <>
                <div style={{ marginBottom: 12 }}>
                  <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Tipo *</label>
                  <select value={form.tipo || ''} onChange={e => setForm({ ...form, tipo: e.target.value })}
                    style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }}>
                    <option value="">Seleccionar...</option>
                    <option value="Reconocimiento periódico">Reconocimiento periódico</option>
                    <option value="Reconocimiento inicial">Reconocimiento inicial</option>
                    <option value="Reconocimiento extraordinario">Reconocimiento extraordinario</option>
                  </select>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
                  <div>
                    <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Fecha</label>
                    <input type="date" value={form.fecha || ''} onChange={e => setForm({ ...form, fecha: e.target.value })}
                      style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Caducidad</label>
                    <input type="date" value={form.fecha_caducidad || ''} onChange={e => setForm({ ...form, fecha_caducidad: e.target.value })}
                      style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
                  </div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
                  <div>
                    <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Resultado</label>
                    <select value={form.resultado || ''} onChange={e => setForm({ ...form, resultado: e.target.value })}
                      style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }}>
                      <option value="">—</option>
                      <option value="Apto">Apto</option>
                      <option value="Apto con restricciones">Apto con restricciones</option>
                      <option value="No apto">No apto</option>
                    </select>
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Centro</label>
                    <input value={form.centro || ''} onChange={e => setForm({ ...form, centro: e.target.value })}
                      style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
                  </div>
                </div>
              </>
            )}

            {modal === 'material' && (
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
                <div>
                  <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Fecha desde</label>
                  <input type="date" value={form.fecha_desde || ''} onChange={e => setForm({ ...form, fecha_desde: e.target.value })}
                    style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Fecha hasta</label>
                  <input type="date" value={form.fecha_hasta || ''} onChange={e => setForm({ ...form, fecha_hasta: e.target.value })}
                    style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
                </div>
              </div>
            )}
            {modal === 'linea' && (
              <div style={{ marginBottom: 12 }}>
                <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Fecha desde</label>
                <input type="date" value={form.fecha_desde || ''} onChange={e => setForm({ ...form, fecha_desde: e.target.value })}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
              </div>
            )}

            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Notas</label>
              <textarea value={form.notas || ''} onChange={e => setForm({ ...form, notas: e.target.value })}
                rows={2} style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13, resize: 'none', boxSizing: 'border-box' }} />
            </div>

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => setModal(null)} style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 13 }}>Cancelar</button>
              <button onClick={guardar} disabled={saving} style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 13, opacity: saving ? 0.7 : 1 }}>
                {saving ? 'Guardando...' : 'Guardar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
